import type { RouteRecordRaw } from "vue-router";

export const qrcodesRoutes: RouteRecordRaw[] = [
  {
    path: "/qrcodes/info",
    name: "qrcodes-info",
    component: () => import("./info.vue"),
    meta: {
      namespace: "qrcodes",
      title: "tools_meta.qrcodes_prefix",
    },
  },
  {
    path: "/qrcodes/qrcodes",
    name: "qrcodes-index",
    component: () => import("./qrcodes.vue"),
    meta: {
      requiresAuth: true,
      namespace: "qrcodes",
      title: "tools_meta.qrcodes_prefix",
    },
  },
];
